// بارگذاری تنبل (lazy) هر صفحه → باندل اولیه‌ی کوچک‌تر و first paint سریع‌تر
const Login = () => import(/* webpackChunkName: "account" */ "@/components/account/Login");
const Register = () => import(/* webpackChunkName: "account" */ "@/components/account/Register");
const Confirm = () => import(/* webpackChunkName: "account" */ "@/components/account/Confirm");
const ForgotPassword = () => import(/* webpackChunkName: "account" */ "@/components/account/ForgotPassword");
const ChangePassword = () => import(/* webpackChunkName: "account" */ "@/components/account/ChangePassword");

const UserProfile = () => import(/* webpackChunkName: "profile" */ "@/components/profiles/UserProfile");
const Wallet = () => import(/* webpackChunkName: "profile" */ "@/components/profiles/Wallet");

const Tickets = () => import(/* webpackChunkName: "crm" */ "@/components/crm/Tickets");
const Ticket = () => import(/* webpackChunkName: "crm" */ "@/components/crm/Ticket");

const Invoice = () => import(/* webpackChunkName: "financial" */ "@/components/financial/Invoice");
const Invoices = () => import(/* webpackChunkName: "financial" */ "@/components/financial/Invoices");

const Dashboard = () => import(/* webpackChunkName: "dashboard" */ "@/components/dashboards/Dashboard");
const Services = () => import(/* webpackChunkName: "dashboard" */ "@/components/dashboards/Services");
const Request = () => import(/* webpackChunkName: "dashboard" */ "@/components/dashboards/Request");
const Download = () => import(/* webpackChunkName: "dashboard" */ "@/components/dashboards/Download");

const Announcements = () => import(/* webpackChunkName: "cms" */ "@/components/cms/Announcements");
const Announcement = () => import(/* webpackChunkName: "cms" */ "@/components/cms/Announcement");

const CareerApply = () => import(/* webpackChunkName: "careers" */ "@/components/careers/CareerApply");

const Error = () => import(/* webpackChunkName: "misc" */ "@/components/pages/Error");
const Calendar = () => import(/* webpackChunkName: "misc" */ "@/components/calendar/Calendar");
const Statistician = () => import(/* webpackChunkName: "tools" */ "@/components/tools/Statistician");
const DepositIdentifier = () => import(/* webpackChunkName: "misc" */ "@/components/deposit/DepositIdentifier");

export default [
    // درخواست همکاری / استخدام — فقط پس از ثبت‌نام و احراز موبایل در پنل کاربری
    {
        path: "/careers",
        name: "CareerApply",
        component: CareerApply,
        meta: { access: ["Client"], title: "درخواست همکاری و رزومه" },
    },
    { path: "/careers/track", redirect: { name: "CareerApply" } },
    {
        path: "/account/login",
        name: "UserLogin",
        component: Login,
        meta: { access: ["*"], title: "ورود" },
    },
    {
        path: "/account/register",
        name: "UserRegister",
        component: Register,
        meta: { access: ["*"], title: "ثبت نام" },
    },
    {
        path: "/account/:id/userConfirm",
        name: "UserConfirm",
        component: Confirm,
        meta: { access: ["*"], title: "تکمیل ثبت نام" },
    },
    {
        path: "/account/forgotPassword",
        name: "ForgotPassword",
        component: ForgotPassword,
        meta: { access: ["*"], title: "فراموشی رمز عبور" },
    },
    {
        path: "/account/:id/resetPassword",
        name: "ResetPassword",
        component: Confirm,
        meta: { access: ["*"], title: "تغییر رمزعبور" },
    },
    {
        path: "/",
        name: "Home",
        component: Dashboard,
        meta: { access: ["Client"], title: "داشبرد" },
    },
    {
        path: "/profile/:id/edit",
        name: "EditProfile",
        component: UserProfile,
        meta: { access: ["Client"], title: "ویرایش پروفایل" },
    },
    {
        path: "/account/:id/changePassword",
        name: "ChangePassword",
        component: ChangePassword,
        meta: { access: ["Client"], title: "تغییر رمزعبور" },
    },
    {
        path: "/tickets/:type?",
        name: "Tickets",
        component: Tickets,
        meta: { access: ["Client"], title: "تیکت ها" },
    },
    {
        // مسیر مجزا؛ قبلاً با /tickets/:type? تداخل داشت و از URL باز نمی‌شد
        path: "/ticket/:ticketId",
        name: "Ticket",
        component: Ticket,
        meta: { access: ["Client"], title: "پاسخ به تیکت" },
    },
    {
        path: "/invoices/:invoiceId",
        name: "Invoice",
        component: Invoice,
        meta: { access: ["Client"], title: "فاکتور" },
    },
    {
        path: "/invoices",
        name: "Invoices",
        component: Invoices,
        meta: { access: ["Client"], title: "فاکتورها" },
    },
    {
        path: "/services/:serviceId",
        name: "Service",
        component: Services,
        meta: { access: ["Client"], title: "سرویس" },
    },
    {
        path: "/services",
        name: "Services",
        component: Services,
        meta: { access: ["Client"], title: "سرویس ها" },
    },
    {
        path: "/request/:type/:id?",
        name: "Request",
        component: Request,
        meta: { access: ["Client"], title: "درخواست ها" },
    },
    {
        path: "/download/:type/",
        name: "download",
        component: Download,
        meta: { access: ["Client"], title: "درخواست ها" },
    },
    {
        path: "/wallet",
        name: "Wallet",
        component: Wallet,
        meta: { access: ["Client"], title: "کیف پول" },
    },
    {
        path: "/Announcements/",
        name: "Announcements",
        component: Announcements,
        meta: { access: ["Client"], title: "آخرین اخبار" },
    },
    {
        path: "/Announcements/:announcementId",
        name: "Announcement",
        component: Announcement,
        meta: { access: ["Client"], title: "اعلامیه" },
    },
    {
        path: "/Statistician/",
        name: "Statistician",
        component: Statistician,
        meta: { access: ["Client"], title: "آمار وب سایت" },
    },
    {
        path: "/DepositIdentifier/",
        name: "DepositIdentifier",
        component: DepositIdentifier,
        meta: { access: ["Client"], title: "شناسه واریز" },
    },
    {
        path: "/calendar/calendar",
        name: "Calendar",
        component: Calendar,
        meta: { title: "تقویم" },
    },
    {
        path: "/Error/:error?",
        name: "Error",
        component: Error,
        meta: { access: ["*"] },
    },
    { path: "/:pathMatch(.*)*", component: Error, meta: { access: ["*"] } },
];
